import script from "./AuthByPhone.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthByPhone.vue?vue&type=script&setup=true&lang=ts"

import "./AuthByPhone.vue?vue&type=style&index=0&id=45430f45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45430f45"]])

export default __exports__